export default __webpack_public_path__ + "39846f1f40a6d94c8630bb51cb0f3a6b.svg";